const MORE_TIME_OFF_EXPORTED = 'More Time Off Exported';
const MORE_HOUR_METER_EXPORTED = 'More Hour Meter Exported';

const moreAnalyticsConstants = {
  MORE_TIME_OFF_EXPORTED,
  MORE_HOUR_METER_EXPORTED,
};

export default moreAnalyticsConstants;
